const isVersionId = id => {
    if (!id) {
        return false;
    }

    return id.startsWith('USES') || id.startsWith('USEN');
};

export default isVersionId;
